const { trim, camelCase } = require('lodash');
const { HTML_CLASS_ATTRIBUTE, HTML_STYLE_ATTRIBUTE } = require('./constants');

/**
 * Creates a style object from inline style string
 * @param  {String} style style string
 * @return {Object} JS style object
 */
const styleStringToObject = (style = '') => style.split(';').reduce((styleObject, property) => {
    if (!property || !trim(property)) { return styleObject; }

    const [name, value] = property.split(':');

    return {
        ...styleObject,
        [camelCase(trim(name))]: trim(value)
    };
}, {});

/**
 * Safely extracts a single property's value from an HTML element.
 * @param  {HTMLElement} element element to from which we wish to extract the attribute.
 * @param  {String} attribute name of the attribute to extract.
 * @return {Object} key:value pair of attribute:name.
 */
const safeAttribute = (element, attribute) => {
    try {
        const value = element.getAttribute(attribute);

        switch (attribute) {
            case HTML_STYLE_ATTRIBUTE:
                return {
                    [attribute]: styleStringToObject(value)
                };
            case HTML_CLASS_ATTRIBUTE:
                return {
                    className: value
                };
            default:
                return {
                    [camelCase(attribute)]: value
                };
        }

    } catch (err) {
        return {};
    }
};

/**
 * Extracts attributes from an HTML element into an object compatible with React.
 * @param  {HTMLElement} element element from which we wish to extract attributes.
 * @return {Object} an object representing attributes and their values.
 */
const getAttributes = (element) => element.getAttributeNames().reduce((attributes, name) => ({
    ...attributes,
    ...safeAttribute(element, name)
}), {});

module.exports = getAttributes;
